import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link_conditional = _resolveComponent("router-link-conditional")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      title: _ctx.link.title,
      class: _normalizeClass([{ 'c-button--with-shadow': _ctx.scrim }, "c-button c-button--current-color relative z-2"])
    }, _toDisplayString(_ctx.link.text || _ctx.link.title), 11, _hoisted_1),
    (_ctx.coverMode)
      ? (_openBlock(), _createBlock(_component_router_link_conditional, {
          key: 0,
          to: _ctx.link.url,
          target: _ctx.link.target,
          title: _ctx.link.title,
          class: "absolute inset-0 z-1"
        }, null, 8, ["to", "target", "title"]))
      : _createCommentVNode("", true)
  ]))
}